import { render } from "./process_documentation_managementFolderModeView.vue?vue&type=template&id=8ab6e414&scoped=true"
import script from "./process_documentation_managementFolderModeView.vue?vue&type=script&lang=js"
export * from "./process_documentation_managementFolderModeView.vue?vue&type=script&lang=js"

import "./process_documentation_managementFolderModeView.vue?vue&type=style&index=0&id=8ab6e414&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab6e414"]])

export default __exports__